import dynamic from 'next/dynamic';
import { useConsentSurface } from './useConsentSurface';

const CookieConsentBanner = dynamic(
  () => import('@discover-components/consent/cookieConsentBanner')
);

/**
 * Shows the cookie-consent banner on GDPR sites. It appears automatically while the diner has not yet decided, and can be re-fired at any time via the "Manage cookies" control so diners can give or withdraw consent.
 */
const GlobalConsentBanner = () => {
  const { shouldShow, accept, reject } = useConsentSurface();

  return shouldShow ? <CookieConsentBanner onAccept={accept} onReject={reject} /> : null;
};

export default GlobalConsentBanner;
